export default {
  scene: {
    background: 0xa49779,
    shadow: 0x3a3552,
    fog: {
      color: 0xa49779,
      near: 50,
      far: 800
    }
  },
  birds: {
    width: 1200,
    height: 300,
    depth: 1200,
    count: 100,
    size: 0.8,
    color: 0x333333,
    cohesion: 0.6,
    separation: 0.8,
    alignment: 0.4,
    position: {
      x: 0,
      y: 140,
      z: -300
    }
  },
  environment: {
    rotation: Math.PI / 2,
    position: {
      x: 0,
      y: -5.1,
      z: 0
    }
  },
  character: {
    timeScale: 1.0,
    rotation: Math.PI / 2,
    position: {
      x: -5,
      y: -5,
      z: 4
    }
  },
  player: {
    timeScale: 1.1,
    rotation: Math.PI / 2,
    position: {
      x: -4,
      y: -5,
      z: -4
    }
  },
  speed: 3
}
